import { getCompanyName } from '@/api/auth'
import { notify } from '@/utils/notify'

const LOCAL_PRINTER_URL = process.env.VUE_APP_PRINTER_URL || 'http://127.0.0.1:8788'
const AUTO_PRINT_KEY = 'sauda_auto_print_zywell'
const PAPER_WIDTH_KEY = 'sauda_paper_width'
export const PAPER_WIDTHS = [58, 80]

export function getPaperWidth() {
  const value = Number(localStorage.getItem(PAPER_WIDTH_KEY))
  return PAPER_WIDTHS.includes(value) ? value : 58
}

export function setPaperWidth(width) {
  const value = PAPER_WIDTHS.includes(Number(width)) ? Number(width) : 58
  localStorage.setItem(PAPER_WIDTH_KEY, String(value))
  return value
}

/** По умолчанию автопечать включена (пока пользователь не выключил). */
export function isAutoPrintEnabled() {
  const value = localStorage.getItem(AUTO_PRINT_KEY)
  if (value === null) return true
  return value === '1'
}

export function setAutoPrintEnabled(enabled) {
  localStorage.setItem(AUTO_PRINT_KEY, enabled ? '1' : '0')
}

export async function getPrinterHealth() {
  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
  const timer = setTimeout(() => {
    if (controller) controller.abort()
  }, 2500)
  try {
    const res = await fetch(`${LOCAL_PRINTER_URL}/health`, {
      method: 'GET',
      signal: controller ? controller.signal : undefined,
    })
    if (!res.ok) return null
    return res.json()
  } catch (error) {
    return null
  } finally {
    clearTimeout(timer)
  }
}

function withPrintOptions(receipt) {
  const payload = receipt && typeof receipt === 'object' ? { ...receipt } : {}
  const company = payload.company || payload.company_name || getCompanyName()
  if (company) {
    payload.company = company
    payload.company_name = company
  }
  payload.width = Number(payload.width) || getPaperWidth()
  payload.paper_width = payload.width
  return payload
}

export async function printReceiptOnZywell(receipt) {
  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
  const timer = setTimeout(() => {
    if (controller) controller.abort()
  }, 10000)

  try {
    const res = await fetch(`${LOCAL_PRINTER_URL}/print`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(withPrintOptions(receipt)),
      signal: controller ? controller.signal : undefined,
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok || data.ok === false) {
      throw new Error((data && data.message) || 'Принтер не ответил')
    }
    return data
  } finally {
    clearTimeout(timer)
  }
}

/**
 * Наклейки со штрихкодом через локальный агент (TSPL BARCODE).
 * Возвращает false, если агент не запущен или старая версия без /labels.
 */
export async function tryPrintBarcodeLabels(payload) {
  const health = await getPrinterHealth()
  if (!health || !health.ok || !health.labels) return false
  if (payload && payload.kind === 'price' && !health.price_labels) return false

  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
  const timer = setTimeout(() => {
    if (controller) controller.abort()
  }, 20000)
  try {
    const res = await fetch(`${LOCAL_PRINTER_URL}/labels`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: controller ? controller.signal : undefined,
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok || data.ok === false) {
      throw new Error((data && data.message) || 'Принтер не ответил')
    }
    return true
  } finally {
    clearTimeout(timer)
  }
}

/**
 * Печать на локальный агент (TSPL/ESC-POS).
 * Если агент недоступен — возвращает false (fallback на browser print).
 */
export async function tryPrintZywell(receipt, { silent = false } = {}) {
  const health = await getPrinterHealth()
  if (!health || !health.ok) {
    if (!silent) {
      notify('Агент печати не запущен (start_printer.bat)', 'warning')
    }
    return false
  }
  try {
    await printReceiptOnZywell(receipt)
    if (!silent) notify('Чек отправлен на принтер')
    return true
  } catch (error) {
    if (!silent) notify((error && error.message) || 'Ошибка печати', 'error')
    return false
  }
}
